package com.ai.mitra.domain.use_cases

import com.ai.mitra.domain.respository.GeminiRepository
import org.koin.core.component.KoinComponent


class DeleteGroupWithMessageUseCase(private val geminiRepository: GeminiRepository) : KoinComponent {
    suspend fun deleteGroupWithMessage(
        groupId: String
    ) {
        geminiRepository.deleteGroupWithMessage(groupId)
    }

}